import { Text, View } from 'react-native';

export const MiniMapLoading = () => (
  <View>
    <Text>...</Text>
  </View>
);
